import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import SaudeService from '../../../../../../services/saude-auth';
import { Link, useParams, Navigate } from 'react-router-dom';


const Remume = () => {
    const { id } = useParams()
    const [nome, setNome] = useState("");
    const [composicao, setComposicao] = useState("");
    const [apresentacao, setApresentacao] = useState("");
    const [disponibilidade, setDisponibilidade] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchRemume(id) {
        const response = await SaudeService.saudeEditRemume(id);
        setNome(response.data["nome"]);
        setComposicao(response.data["composicao"]);
        setApresentacao(response.data["apresentacao"]);
        setDisponibilidade(response.data["disponibilidade"]);
    }

    useEffect(() => {
        fetchRemume(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const med = await SaudeService.editarRemume(id, {
                nome: nome,
                composicao: composicao,
                apresentacao: apresentacao,
                disponibilidade: disponibilidade
            })
            if (med.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Medicamento"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="composicao">
                                <FloatingLabel
                                    label="Composição/Concentração"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="composicao"
                                        value={composicao}
                                        onChange={e => setComposicao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="apresentacao">
                                <FloatingLabel
                                    label="Apresentação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="apresentacao"
                                        value={apresentacao}
                                        onChange={e => setApresentacao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Disponibilidade">
                                <FloatingLabel
                                    label="Disponível?"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Disponibilidade"
                                        name="disponibilidade"
                                        onChange={e => setDisponibilidade(e.target.value)}
                                    >
                                        <option value={disponibilidade}>{disponibilidade}</option>
                                        <option value="Com estoque">Com estoque</option>
                                        <option value="Sem estoque">Sem estoque</option>
                                        <option value="Aguardando chegada">Aguardando chegada</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/saude/remume/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Medicamento editado com sucesso!</Alert>
                <Navigate to={'/restrito/saude/remume/listar'} />
            </Fragment>
        )
    }
}

export default Remume;